export default {
  all: [],
  one: {},
  newArticle: {},
  clickedBy: {},
};
